<template>
  <div class="m-b-30 ">
    <a href="" @click.prevent="showSearch = !showSearch">Show Search Options</a>
    <transition name="slide">
    <div class="search-box" v-show="showSearch">
      <b-row>
        <b-col cols="6">
           <label for="">Order Nos.</label>
           <b-form-input size="lg" v-model="search.orderNos" placeholder="Order Nos." @change="searchFnc(search)"></b-form-input>
           <p class="m-t-10 text-info">Comma separated order nos. eg ORDERNO1, ORDERNO2</p>
        </b-col>
      </b-row>
    </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      searchFnc: {
        type: Function,
      }
    },
    data(){
      return {
        showSearch: false,
        search: {
          orderNos: ''
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .search-box{
     padding: 30px;
     border: 1px solid rgb(187, 199, 230);
     background-color: rgb(244, 247, 255);
     border-radius: 5px;
     label{
       color: rgb(58, 77, 121);
       font-weight: 600;
     }
  }

  .slide-enter-active {
      animation: slide-in 0.5s;
    }
    .slide-leave-active {
      animation: slide-in reverse 0.5s;
    }
    @keyframes slide-in {
      from {
        transform: translateX(100px);
      }
      to {
        transform: translateX(0);
      }
    }

</style>